<template>
  <div class="station-performance-container">
    
    <div class="station-performance-list">
      <Spinner v-if="loading" />
      <div class="row" v-if="!loading">
        <div class="col-3">
        </div>
        <div class="col-3">
          <StationMonthlyNCRWidget :startDate="statsSummaryData.startDate" :summaryData="statsSummaryData.ncrSummary" />
        </div>
        <div class="col-3">
          <StationMonthlyRecutWidget :startDate="statsSummaryData.startDate" :summaryData="statsSummaryData.recutSummary" />
        </div>
      </div>

      <h1 class="text-center">Station Performance</h1>
      <Spinner v-if="loading" />
      <div class="station-performance-graph-container row no-gutters" v-if="!loading">
        <template v-for="station of stationList">
          <div class="graph-container col-3 float-left" :key="station.id" v-if="station.showStationGraph">
            <h2 :class="['graph-title', 'text-truncate', {'graph-title-active': isCurrentStation(station)}]">{{stationStageName(station)}} - {{station.name}}</h2>
            <StationPerformanceGraph :productionStation="station" />
          </div>
        </template>
      </div>

    </div>
  </div>
</template>

<style scoped>
.station-performance-container {
  width: 100%;
  height: 100%;
  flex: 100%;
  position: relative;
  flex-direction: column;
  align-items: stretch;
}
.graph-title {
  font-size: 18px;
  margin-top: 0px;
  margin-bottom: 5px;
}
.theme-dark .graph-title {
  color: #b0b0b0;
}
.graph-title-active {
  color: #2FB2E6 !important;
}
.graph-container {
  padding: 10px;
  margin-bottom: 8px;
}
.station-performance-list {
  position: absolute;
  top: 0; left: 0;
  right: 0; bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0.75rem;
}
</style>

<script>
import StationPerformanceGraph from '@/apps/glass-production-station/src/components/stationPerformanceGraph'
import StationMonthlyNCRWidget from '@/apps/glass-production-station/src/components/widgets/stationMonthlyNCRWidget'
import StationMonthlyRecutWidget from '@/apps/glass-production-station/src/components/widgets/stationMonthlyRecutWidget'

export default {
  name: 'StationPerformancePageView',
  components: {
    StationPerformanceGraph,
    StationMonthlyNCRWidget,
    StationMonthlyRecutWidget
  },
  props: {
    productionStationId: Number
  },
  data() {
    return {
      loading: true,
      stationList: [],
      statsSummaryData: {}
    }
  },
  mounted() {
    this.requestData()
  },
  methods: {
    requestData() {
      this.loading = true
      Promise.all([
        this.$apiService.productionService.getProductionStationList(),
        this.$apiService.glassProductionStationService.getProductionStationStatsSummary(this.$props.productionStationId),
      ])
      .then(results => {
        this.$data.stationList = results[0].data
        this.$data.statsSummaryData = results[1].data
      })
      .catch(err => {
      })
      .finally(() => {
        this.loading = false
      })
    },
    stationStageName(station) {
      if(station.productionStages && station.productionStages.length > 0) {
        return station.productionStages[0].name
      }
      return 'None'
    },
    isCurrentStation(station) {
      return station.id == this.productionStationId
    }
  }
}
</script>